import { render, staticRenderFns } from "./EmptyComponent.vue?vue&type=template&id=a4417658&v-slot%3ArenderEmpty=true&"
import script from "./EmptyComponent.vue?vue&type=script&lang=js&"
export * from "./EmptyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports